import React from 'react';
import { Box, Typography, Container, Grid, Paper, Button, Divider } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import VerifiedIcon from '@mui/icons-material/Verified';
import DescriptionIcon from '@mui/icons-material/Description';

const LandingAbout = () => {
  return (
    <Box id="about" sx={{ py: 12, bgcolor: 'white' }}>
      <Container maxWidth="lg">
        <Grid container spacing={8} sx={{ alignItems: "center" }}>
          <Grid >
            <Box sx={{ position: 'relative' }}>
              <Box
                sx={{
                  position: 'absolute',
                  top: -20,
                  left: -20,
                  width: '100px',
                  height: '100px',
                  bgcolor: 'primary.light',
                  opacity: 0.1,
                  borderRadius: '20px',
                  zIndex: 0
                }}
              />
              <Typography
                variant="overline"
                sx={{ fontWeight: 800, color: 'primary.main', letterSpacing: 2, position: 'relative', zIndex: 1 }}
              >
                CONÓCENOS
              </Typography>
              <Typography
                variant="h3"
                sx={{ fontWeight: 900, mt: 1, color: '#001a33', position: 'relative', zIndex: 1 }}
              >
                Nuestra Misión y Visión Institucional
              </Typography>
              <Typography
                variant="body1"
                sx={{ mt: 3, mb: 4, color: 'text.secondary', lineHeight: 1.8, fontSize: '1.1rem' }}
              >
                En AGUA POTABLE, nos dedicamos a la administración responsable del recurso hídrico, asegurando que cada miembro de la comunidad reciba agua de la más alta calidad mediante una infraestructura moderna y sostenible.
              </Typography>

              <Grid container spacing={3}>
                <Grid >
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <VerifiedIcon color="primary" />
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>Compromiso</Typography>
                      <Typography variant="body2" color="text.secondary">Lealtad con cada usuario y su bienestar.</Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid >
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <BusinessIcon color="primary" />
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>Infraestructura</Typography>
                      <Typography variant="body2" color="text.secondary">Sistemas de última generación.</Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid >
            <Paper
              elevation={0}
              sx={{
                p: 4,
                borderRadius: '32px',
                bgcolor: '#f8f9fa',
                border: '1px solid rgba(0,0,0,0.05)',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: 800, mb: 3, color: '#001a33' }}>
                Documentación Institucional
              </Typography>
              <Typography variant="body2" sx={{ mb: 4, color: 'text.secondary' }}>
                Accede a los pilares legales y administrativos que rigen nuestra organización.
              </Typography>

              <DocItem icon={<DescriptionIcon />} title="Estatutos Orgánicos" description="Normas y reglamentos que definen nuestra estructura." />
              <Divider sx={{ my: 2 }} />
              <DocItem icon={<DescriptionIcon />} title="Plan de Trabajo 2025-2026" description="Nuestras metas y proyecciones a corto y mediano plazo." />
              <Divider sx={{ my: 2 }} />
              <DocItem icon={<BusinessIcon />} title="Nosotros" description="Nuestra historia y evolución como institución." />

              <Button
                variant="contained"
                fullWidth
                size="large"
                sx={{
                  mt: 4,
                  borderRadius: '16px',
                  fontWeight: 700,
                  py: 1.5,
                  boxShadow: '0 8px 16px rgba(0,0,0,0.05)'
                }}
              >
                DESCARGAR REGLAMENTACIÓN
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

const DocItem = ({ icon, title, description }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, cursor: 'pointer', '&:hover': { '& .title': { color: 'primary.main' } } }}>
    <Box sx={{ p: 1, bgcolor: 'white', borderRadius: '12px', color: 'primary.main', display: 'flex', boxShadow: '0 4px 10px rgba(0,0,0,0.03)' }}>
      {icon}
    </Box>
    <Box>
      <Typography className="title" variant="subtitle1" sx={{ fontWeight: 800, transition: 'color 0.2s' }}>{title}</Typography>
      <Typography variant="body2" color="text.secondary">{description}</Typography>
    </Box>
  </Box>
);

export default LandingAbout;
